<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h3 class="text-center text-primary">Registrar Nueva Sede: {{ sede.nombre }}</h3>
    <p class="text-center"><small> Complete el siguiente formulario</small></p>

    <form class="xcard" @submit.prevent="validarCampos" novalidate>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <div class="input-group input-group-sm" :class="{ 'has-error': validation.hasError('sede.idciudad') }">
              <div class="input-group-addon">*Ciudad</div>
              <ACiudades :model="sede" :default="sede.idciudad" />
            </div>
            <div class="error" v-if="validation.hasError('sede.idciudad')">
              {{ validation.firstError('sede.idciudad') }}
            </div>
          </div>

          <div class="form-group">
            <div class="input-group input-group-sm" :class="{ 'has-error': validation.hasError('sede.nombre') }">
              <div class="input-group-addon">*Nombre</div>
              <input v-model.trim="sede.nombre" type="text" class="form-control" placeholder="Caracteres alfabeticos" />
            </div>
            <div class="error" v-if="validation.hasError('sede.nombre')">
              {{ validation.firstError('sede.nombre') }}
            </div>
          </div>

          <div class="form-group">
            <div class="input-group input-group-sm" :class="{ 'has-error': validation.hasError('sede.direccion') }">
              <div class="input-group-addon">*Direccion</div>
              <input
                v-model.trim="sede.direccion"
                type="text"
                class="form-control"
                placeholder="Caracteres alfabeticos" />
            </div>
            <div class="error" v-if="validation.hasError('sede.direccion')">
              {{ validation.firstError('sede.direccion') }}
            </div>
          </div>

          <div class="form-group">
            <div class="input-group input-group-sm" :class="{ 'has-error': validation.hasError('sede.telefono_fijo') }">
              <div class="input-group-addon">*Telefono fijo</div>
              <input
                v-model.trim="sede.telefono_fijo"
                type="text"
                class="form-control"
                placeholder="Caracteres alfabeticos" />
            </div>
            <div class="error" v-if="validation.hasError('sede.telefono_fijo')">
              {{ validation.firstError('sede.telefono_fijo') }}
            </div>
          </div>

          <div class="form-group">
            <div
              class="input-group input-group-sm"
              :class="{ 'has-error': validation.hasError('sede.unidad_negocio') }">
              <div class="input-group-addon">*Unidad Negocio</div>
              <select class="form-control input-sm" type="text" v-model.number="sede.unidad_negocio">
                <option v-for="(u, ind) in unidades" :key="ind" :value="u.id">{{ u.nombre }}</option>
              </select>
            </div>
            <div class="error" v-if="validation.hasError('sede.unidad_negocio')">
              {{ validation.firstError('sede.unidad_negocio') }}
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <div class="input-group input-group-sm" :class="{ 'has-error': validation.hasError('sede.telefono1') }">
              <div class="input-group-addon">Telefono 1</div>
              <input
                v-model.trim="sede.telefono1"
                type="text"
                class="form-control"
                placeholder="Caracteres alfabeticos" />
            </div>
            <div class="error" v-if="validation.hasError('sede.telefono1')">
              {{ validation.firstError('sede.telefono1') }}
            </div>
          </div>

          <div class="form-group">
            <div class="input-group input-group-sm" :class="{ 'has-error': validation.hasError('sede.telefono2') }">
              <div class="input-group-addon">Telefono 2</div>
              <input
                v-model.trim="sede.telefono2"
                type="text"
                class="form-control"
                placeholder="Caracteres alfabeticos" />
            </div>
            <div class="error" v-if="validation.hasError('sede.telefono2')">
              {{ validation.firstError('sede.telefono2') }}
            </div>
          </div>

          <div class="form-group">
            <div class="input-group input-group-sm" :class="{ 'has-error': validation.hasError('sede.latitud') }">
              <div class="input-group-addon">Latitud</div>
              <input
                v-model.trim="sede.latitud"
                type="text"
                class="form-control"
                placeholder="Caracteres alfabeticos" />
            </div>
            <div class="error" v-if="validation.hasError('sede.latitud')">
              {{ validation.firstError('sede.latitud') }}
            </div>
          </div>

          <div class="form-group">
            <div class="input-group input-group-sm" :class="{ 'has-error': validation.hasError('sede.longitud') }">
              <div class="input-group-addon">Longitud</div>
              <input
                v-model.trim="sede.longitud"
                type="text"
                class="form-control"
                placeholder="Caracteres alfabeticos" />
            </div>
            <div class="error" v-if="validation.hasError('sede.longitud')">
              {{ validation.firstError('sede.longitud') }}
            </div>
          </div>

          <div class="form-group">
            <div
              class="input-group input-group-sm"
              :class="{ 'has-error': validation.hasError('gerentesel.idusuario') }">
              <Usuarios :current="false" :model="gerentesel" :xdefault="sede.gerente_id" />
              <label class=""> <small> Gerente Sede (firmante del contrato/certificados)</small></label>
            </div>
            <div class="error" v-if="validation.hasError('gerentesel.idusuario')">
              {{ validation.firstError('gerentesel.idusuario') }}
            </div>
          </div>
        </div>
      </div>

      <v-row>
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="sede.zona_franca"
            :label="sede.zona_franca ? 'Es zona franca' : 'No es zona franca'"
            hide-details></v-checkbox>
        </v-col>
      </v-row>
      <v-divider class="my-2"></v-divider>

      <p>
        <small class="text-primary">Correos: </small>
        <a href="#" class="btn btn-link btn-sm" @click="addCorreosView">
          <span class="glyphicon glyphicon-plus"></span>
        </a>
        <a href="#" class="btn btn-link btn-sm" @click="delCorreosView">
          <span class="glyphicon glyphicon-minus"></span>
        </a>
      </p>
      <div class="row">
        <div class="col-sm-12">
          <div :key="ind" v-for="(r, ind) in sede.correos">
            <div class="row" style="margin-bottom: 4px">
              <div class="col-sm-3">
                <input
                  class="form-control input-sm"
                  type="text"
                  v-model="r.nombre"
                  placeholder="nombre"
                  required="true" />
              </div>
              <div class="col-sm-6">
                <input
                  class="form-control input-sm"
                  type="text"
                  v-model="r.direccion"
                  placeholder="direccion"
                  required="true" />
              </div>
              <div class="col-sm-3">
                <select name="d" class="form-control input-sm" v-model="r.tipo" placeholder="tipo">
                  <option value="0">0 Corporativo</option>
                  <option value="1">1 Personal</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />

      <p>
        <small class="text-primary">Redes sociales: </small>
        <a href="#" class="btn btn-link btn-sm" @click="addRedesView">
          <span class="glyphicon glyphicon-plus"></span>
        </a>
        <a href="#" class="btn btn-link btn-sm" @click="delRedesView">
          <span class="glyphicon glyphicon-minus"></span>
        </a>
      </p>
      <div class="row">
        <div class="col-sm-12">
          <div :key="ind" v-for="(r, ind) in sede.redesSociales">
            <div class="row" style="margin-bottom: 4px">
              <div class="col-sm-3">
                <input
                  class="form-control input-sm"
                  type="text"
                  v-model="r.nombre"
                  placeholder="nombre"
                  required="true" />
              </div>
              <div class="col-sm-6">
                <input
                  class="form-control input-sm"
                  type="text"
                  v-model="r.direccion"
                  placeholder="direccion"
                  required="true" />
              </div>
              <div class="col-sm-3">
                <select class="form-control input-sm" type="number" v-model="r.tipo" placeholder="tipo">
                  <option value="0">Facebook</option>
                  <option value="1">Youtube</option>
                  <option value="2">Instagram</option>
                  <option value="3">Twitter</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p>
        <small class="text-primary">Cuentas Bancarias: </small>
        <a href="#" class="btn btn-link btn-sm" @click="addBancoView">
          <span class="glyphicon glyphicon-plus"></span>
        </a>
        <a href="#" class="btn btn-link btn-sm" @click="delBancoView">
          <span class="glyphicon glyphicon-minus"></span>
        </a>
      </p>
      <div class="row">
        <div class="col-sm-12">
          <div :key="ind" v-for="(r, ind) in sede.cuentasBancarias">
            <div class="row" style="margin-bottom: 4px">
              <div class="col-sm-3">
                <input
                  class="form-control input-sm"
                  maxlength="100"
                  type="text"
                  v-model.trim="r.nombre"
                  placeholder="nombre del banco"
                  required="true" />
              </div>
              <div class="col-sm-3">
                <input
                  class="form-control input-sm"
                  maxlength="20"
                  type="text"
                  v-model.trim="r.nro"
                  placeholder="nro de cuenta"
                  required="true" />
              </div>
              <div class="col-sm-3">
                <input
                  class="form-control input-sm"
                  maxlength="500"
                  type="text"
                  v-model.trim="r.descripcion"
                  placeholder="descripcion"
                  required="true" />
              </div>
              <div class="col-sm-3 pb-0">
                <buscarCaja ref="refBuscarCaja" v-on:onselect="onselectCajaNetSuite($event,r)" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="xcard">
        <p class="text-center text-primary">
          Fondo de recibo para sede (840x700)
          <!-- <a href="formato.psd" target="_blank" rel="">Descargar Formato ".psd" (tamano) </a> -->
        </p>
        <div class="form-group form-group-sm">
          <div class="input-group input-group-sm">
            <div class="input-group-addon">
              <label for="reciboFile" class="btn btn-rounded btn-primary">Seleccione un fondo de recibo</label>
              <input
                type="file"
                style="visibility: hidden"
                id="reciboFile"
                @click="resetImageUploader"
                @change="uploadReciboSede"
                accept=".jpg, .jpeg, .png"
                ref="reciboFile" />
            </div>
          </div>
          <input type="hidden" v-model.trim="sede.modelo_recibo" />
        </div>
        <div class="container-fluid">
          <img class="img-responsive" alt="recibo fondo" :src="location_bd_recibo_sede + sede.modelo_recibo" />
        </div>
      </div>

      {{ activo }}
      <button :disabled="!activo" type="submit" class="btn btn-sm btn-azul center-block">Aceptar</button>
    </form>
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <Alertas ref="alertar" />
    <notifications group="auth" position="bottom right" />
    <notifications group="auth3" position="bottom right" />
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  import { Validator } from 'simple-vue-validator';
  import ACiudades from '@/components/ACiudades';
  import { error, exito } from '@/components/Utils.js';
  import Alertas from '@/components/AAlertas.vue';
  import xaxios from '@/xaxios';
  import Usuarios from '@/components/AUsuariosActivos';
  import buscarCaja from '@/views/conceptos/buscarCaja.vue';

  export default {
    data() {
      return {
        activo: true,
        menu_name: process.env.VUE_APP_NAME_MENU,
        location_bd_recibo_sede: process.env.VUE_APP_URL_BG_RECIBO_SEDE,
        gerentesel: { idusuario: '' },
        sede: {
          id: -1,
          nombre: '',
          direccion: '',
          telefono_fijo: '',
          telefono1: null,
          telefono2: null,
          idciudad: null,
          latitud: null,
          longitud: null,
          unidad_negocio: null,
          redesSociales: [],
          cuentasBancarias: [],
          correos: [],
          modelo_recibo: '',
          gerente_id: null,
          //zona_franca: false,
        },
        unidades: [],
      };
    },
    components: { ACiudades, Alertas, Usuarios, buscarCaja },
    validators: {
      'sede.nombre'(value) {
        return Validator.value(value).required();
      },
      'sede.direccion'(value) {
        return Validator.value(value).required();
      },
      'sede.telefono_fijo'(value) {
        return Validator.value(value).required();
      },
      'sede.telefono1'(value) {
        return Validator.value(value).digit().minLength(5).maxLength(12);
      },
      'sede.telefono2'(value) {
        return Validator.value(value).digit().minLength(5).maxLength(12);
      },
      'sede.idciudad'(value) {
        return Validator.value(value).required();
      },
      'gerentesel.idusuario'(value) {
        return Validator.value(value).required();
      },
    },
    methods: {
      resetImageUploader: function () {
        this.sede.modelo_recibo = null;
        this.$refs.reciboFile.value = '';
      },
      uploadReciboSede: function () {
        const img_file = this.$refs.reciboFile.files[0];
        if (img_file.size / 1000 < 1024) {
          let url = `${process.env.VUE_APP_URL_WEBDATA}recibo_upload.php`;

          let formData = new FormData();
          formData.append('file', img_file);

          xaxios
            .post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(({ data: { status, msg, fileNameRecibo } }) => {
              this.sede.modelo_recibo = status ? fileNameRecibo : null;
              this.$notify(exito('Recibo ', msg));
            })
            .catch((error) => {
              this.resetImageUploader();
              this.$notify(error('Error: ' + url, error));
            });
        } else {
          this.resetImageUploader();
          this.$notify(error('Recibo', 'El archivo debe ser Menor a 1MB'));
        }
      },
      validarCampos() {
        var vue = this;
        this.$validate().then((success) => {
          var obj = window.Object.assign({}, this.sede); 
          
          if (obj.idciudad) obj.idciudad = obj.idciudad.id;
          if (obj.redesSociales.length == 0) delete obj.redesSociales;
          if (obj.correos.length == 0) delete obj.correos;
          if (obj.cuentasBancarias.length == 0) delete obj.cuentasBancarias;
          if (!obj.unidad_negocio) delete obj.unidad_negocio;
          delete obj.idsede;
          
          /*else{
            const UnidadNegocio = {
              CCA:'CCA',
              ESAM:'ESAM',
              CYBERCORP:'CYBERCORP',
              CIBERKIDS:'CIBERKIDS',
              FORMACION_CONTINUA:'FORMACION_CONTINUA',
              INTRADIGITAL:'INTRADIGITAL',
              DIGITAL_ACADEMY:'DIGITAL_ACADEMY',
            };
            obj.unidad_negocio = UnidadNegocio[obj.unidad_negocio];
          }*/

          var exito = success;
          if (obj.correos) {
            obj.correos.forEach(function (e) {
              if (e.nombre.length == 0) {
                vue.$notify(error('Correo', 'Ingrese el nombre del correo'));
                exito = false;
                return;
              }
              if (e.direccion.length == 0) {
                vue.$notify(error('Correo', 'Ingrese el correo'));
                exito = false;
                return;
              }
              e.tipo = parseInt(e.tipo);
            });
            if (!exito) return;
          }
          if (!vue.gerentesel.idusuario) {
            vue.$notify(error('Gerente Sede', 'Seleccione al gerente de la sede, para el contrato.'));
            exito = false;
            return;
          }
          if (obj.redesSociales) {
            obj.redesSociales.forEach(function (e) {
              if (e.nombre.length == 0) {
                vue.$notify(error('Red social', 'Ingrese el nombre del correo'));
                exito = false;
                return;
              }
              if (e.direccion.length == 0) {
                vue.$notify(error('Red social', 'Ingrese el correo'));
                exito = false;
                return;
              }
              e.tipo = parseInt(e.tipo);
            });
            if (!exito) return;
          }
          if (obj.cuentasBancarias) {
            obj.cuentasBancarias.forEach(function (e) {
              if (e.nombre.length == 0) {
                vue.$notify(error('Cuenta Bancaria', 'Ingrese el nombre del banco'));
                exito = false;
                return;
              }
              if (e.descripcion.length == 0) {
                vue.$notify(error('Cuenta Bancaria', 'Ingrese una descripcion de la cuenta'));
                exito = false;
                return;
              }
              if (e.nro.length == 0) {
                vue.$notify(error('Cuenta Bancaria', 'Ingrese el numero de la cuenta'));
                exito = false;
                return;
              } else if (e.nro.length < 7 || e.nro.length > 20) {
                vue.$notify(error('Cuenta Bancaria', 'La cuenta debe tener entre 7 y 20 digitos'));
                exito = false;
                return;
              } else if (!/^\d+$/.test(e.nro)) {
                vue.$notify(error('Cuenta Bancaria', 'La cuenta solamente debe tener entre 7 y 20 digitos'));
                exito = false;
                return;
              }
            });
            if (!exito) return;
          }
          window.console.log('obj', obj);
          if (exito) {
            vue.activo = false;
            delete obj.idsede;
            vue.enviarDatos(obj);
          } else {
            vue.activo = false;
            vue.$notify(error('Sede', 'Revise los datos ingresados'));
          }
        });
      },
      addCorreosView() {
        this.sede.correos.push({ nombre: '', direccion: '', tipo: 0, idsede: this.sede.id });
      },
      delCorreosView() {
        this.sede.correos.pop();
        window.console.log(this.sede.correos);
      },
      addRedesView() {
        this.sede.redesSociales.push({ nombre: '', direccion: '', tipo: 0, idsede: this.sede.id });
      },
      delRedesView() {
        this.sede.redesSociales.pop();
        window.console.log(this.sede.redesSociales);
      },
      addBancoView() {
        this.sede.cuentasBancarias.push({ nombre: '', descripcion: '', nro: '', idsede: this.sede.id });
      },
      delBancoView() {
        this.sede.cuentasBancarias.pop();
        window.console.log(this.sede.cuentasBancarias);
      },
      async getunidades() {
        var vue = this;
        this.loadingunidades = true;
        let s = `query { NegociosAll { id nombre } }`;
        var sql = gql`
          ${s}
        `;
        await this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            var dat = data.data.NegociosAll;
            dat.map((x) => {
              x.text = x.nombre;
            });
            vue.unidades = dat;
            vue.loadingunidades = false;
          })
          .catch((error) => {
            vue.loadingunidades = false;
            window.console.error(error);
          });
      },
      enviarDatos(obj) {
        var vue = this;
        vue.$refs.alertar.cargando();
        var unidad = obj.unidad_negocio;
        if (unidad) {
          obj.unidad_negocio = '1';
        }
        delete obj.id;
        if (!obj.latitud) delete obj.latitud;
        if (!obj.longitud) delete obj.longitud;
        if (!obj.telefono1) delete obj.telefono1;
        if (!obj.telefono2) delete obj.telefono2;
        if (!obj.modelo_recibo) delete obj.modelo_recibo;
        obj.gerente_id = vue.gerentesel.idusuario.id;
        if(obj.cuentasBancarias){
          obj.cuentasBancarias.forEach(b=> delete b.idsede);
        }
        window.console.log(obj);
        var ob = window.stringifyObject(obj);
        if (ob.includes('unidad_negocio')) {
          ob = ob.replace('unidad_negocio: "1"', 'unidad_negocio:' + unidad);
        }

        var sql = gql`mutation{createSede(input:${ob}){ok,errors{message}}}`;
        window.console.log('---------------*-*\n', sql);

        this.$apollo
          .mutate({
            mutation: sql,
          })
          .then((data) => {
            var res = data.data.createSede;
            window.console.log(res);
            if (res.ok) {
              this.$notify(exito('Sede', 'Datos actualizados.'));
              vue.$refs.alertar.success();
            } else {
              this.activo = true;
              var errores = JSON.stringify(data.data.createSede.errors);
              var ob = JSON.parse(errores);
              var vals = '';
              ob.forEach(function (k) {
                delete k.__typename;
                vals += Object.values(k) + ' \n\t';
              });
              this.$notify(error('Sede', vals));
              vue.$refs.alertar.invalido(vals);
            }
          })
          .catch((error) => {
            window.console.error(error);
            vue.activo = true;
            vue.$refs.alertar.invalido();
          });
      },
      onselectCajaNetSuite(e,r){
        window.console.log('>>>>>>>>>>>>>>>>>>',e,r);
        if(e) r.cuenta_netsuite_id = e.id;
        else delete r.cuenta_netsuite_id;
      },
    },
    mounted() {
      this.getunidades();
    },
  };
</script>
